<template>
    <div class="disable-selection tag-icons">
        <v-tooltip v-if="tagMap[tag]" :color="tagMap[tag].tooltipColor || undefined" open-delay="750" bottom>
            <template #activator="{ on }">
                <v-chip x-small class="px-1 cp" v-on="on" :color="tagMap[tag].color" label>
                    <span class="text--primary">{{ tagMap[tag].label }}</span>
                </v-chip>
            </template>
            <span class="tooltip-content">{{ tagMap[tag].tooltip }}</span>
        </v-tooltip>
    </div>
</template>

<script>
export default {
    props: {
        tag: {
            required: true,
            type: String,
        },
    },
    computed: {
        tagMap() {
            return {
                es: {
                    label: "ES",
                    color: "green lighten-3",
                    tooltip: "Evaluation Service",
                },
                errata: {
                    label: "E",
                    color: "red lighten-3",
                    tooltip: "Content Updates",
                },
                cdp: {
                    label: "CDP",
                    color: "'blue lighten-3",
                    tooltip: "Code Development Proposal",
                },
                srcc: {
                    label: "S",
                    color: "green lighten-3",
                    tooltip: "Solar Rating and Certification Corporation",
                },
            };
        },
    },
};
</script>
